import React, {ReactNode} from "react";
import "./style.scss";
const Card = ({content}: {content: ReactNode}) => {
	return <div className="content-chart">{content}</div>;
};

export default Card;
